import useBindActionCreators from 'common/hooks/useBindActionCreators';

import operations from '../operations';

export const useApplicationOperations = () => {
  const bindedActions = useBindActionCreators(operations);
  return bindedActions;
};

export default useApplicationOperations;
